import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";
import { IconGridFragment } from "./IconGridFragment";
import { ArticleSideBySideImageFragment } from "./ArticleSideBySideImageFragment";

export const RichTextFragment = graphql(
  /* GraphQL */ `
    fragment RichTextFragment on ContentTypeRichText {
      richText {
        json
        links {
          entries {
            inline {
              sys {
                id
              }
              __typename
              ... on Link {
                ...LinkFragment
              }
            }
            block {
              sys {
                id
              }
              __typename
              ... on Link {
                ...LinkFragment
              }
              ... on IconGrid {
                ...IconGridFragment
              }
              ... on SideBySideMedia {
                ...ArticleSideBySideImageFragment
              }
            }
            hyperlink {
              sys {
                id
              }
              __typename
              ... on ArticlePage {
                slug
              }
              ... on ContentHubPage {
                slug
              }
              ... on ConversionPage {
                slug
              }
              ... on EditorialPage {
                slug
              }
              ... on FaqPage {
                slug
              }
              ... on Homepage {
                slug
              }
              ... on ProductPage {
                slug
              }

              ... on TermsPage {
                slug
              }
              ... on CreativeSpecsPage {
                slug
              }
            }
          }
          assets {
            __typename
            block {
              sys {
                id
              }
              url
              contentType
            }
          }
        }
      }
    }
  `,
  [LinkFragment, IconGridFragment, ArticleSideBySideImageFragment]
);
